import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

export const useQueryParamModalVisibility = (paramName: string): boolean => {
  const location = useLocation();

  const hasParam = useMemo(() => {
    const search = location.search.toLowerCase();
    const queryParams = new URLSearchParams(search);
    return queryParams.has(paramName.toLowerCase());
  }, [location.search, paramName]);

  return hasParam;
};
